module.exports = __webpack_public_path__ + "static/media/T2.290d10ec.jpg";